import React from 'react';
import cx from 'clsx';
import classes from './Button.module.scss';

export default function Button({ className, ...others }: React.HTMLProps<HTMLButtonElement>) {
  return (
    //@ts-ignore
    <button type="button" className={cx(classes.button, className)} {...others} />
  );
}
